export default "__VITE_ASSET__CLx_69h9__"